export default {"src":"/_next/static/media/star_24.7fd39f43.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};